import { render } from "./InterfaceWindows.vue?vue&type=template&id=5361ab24&scoped=true"
import script from "./InterfaceWindows.vue?vue&type=script&lang=js"
export * from "./InterfaceWindows.vue?vue&type=script&lang=js"

import "./InterfaceWindows.vue?vue&type=style&index=0&id=5361ab24&scoped=true&lang=scss"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5361ab24"]])

export default __exports__